import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Contentful from '../../contentful';
import styles from './header.scss';
import logo from '../../../assets/images/logo.svg';
import ukFlag from '../../../assets/images/flags/uk.svg';
import cnFlag from '../../../assets/images/flags/cn.svg';
import jpFlag from '../../../assets/images/flags/jp.svg';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNavigation: false
    }

    this.toggleNavigation = this.toggleNavigation.bind(this);
  }

  toggleNavigation() {
    this.setState({ showNavigation: !this.state.showNavigation });
  }

  render() {
    const { showNavigation } = this.state;

    return (
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <NavLink to="/" className={styles.home}>
              <img src={logo} className={styles.logo} alt="HANNWEBER"/>
            </NavLink>
            <div className={styles.navigationWrapper} data-open={showNavigation}>
              <div className={styles.languages}>
                <Contentful query={{ content_type: 'navigationZone', limit: 1, 'fields.title': 'Languages' }}>
                  {({ items }) => {
                    if (items.length === 0) { return null; }
                    const languages = items[0].fields.items;
                    return languages.map(item => {
                      const flag = item.fields.slug === 'en' ? ukFlag : item.fields.slug === 'chineese' ? cnFlag : jpFlag;

                      return (
                        <NavLink key={item.sys.id} to={'/' + item.fields.slug}>
                          <img src={flag} alt={`Switch to ${item.fields.title}`}/>
                        </NavLink>
                      )
                    })
                  }}
                </Contentful>
              </div>
              <Contentful query={{ content_type: 'navigationZone', limit: 1, 'fields.title': 'Main' }}>
                {({ items }) => {
                  if (items.length === 0) { return null; }
                  const mainItems = items[0].fields.items;
                  return (
                    <nav className={styles.navigation}>
                      { mainItems.map(item => (
                        <NavLink className={styles.navLink} to={'/' + item.fields.slug || '/'} key={item.sys.id} onClick={this.toggleNavigation}>
                          {item.fields.title}
                        </NavLink>
                      )) }
                    </nav>
                  )
                }}
              </Contentful>
              <Contentful query={{ content_type: 'navigationZone', limit: 1, 'fields.title': 'Action' }}>
                {({ items }) => {
                  if (items.length === 0) { return null; }
                  const mainItems = items[0].fields.items;
                  return (
                    <nav className={[styles.navigation, styles.navigationAction].join(' ')}>
                      { mainItems.map(item => (
                        <NavLink className={styles.navLink} to={'/' + item.fields.slug || ''} key={item.sys.id} onClick={this.toggleNavigation}>
                          {item.fields.title}
                        </NavLink>
                      )) }
                    </nav>
                  )
                }}
              </Contentful>
            </div>
            <div className={styles.toggle} onClick={this.toggleNavigation} data-open={showNavigation}>
              <span className={styles.bar}/>
              <span className={styles.bar}/>
              <span className={styles.bar}/>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/header/header.jsx